import { render } from "./AppFooter.vue?vue&type=template&id=54ea2d86"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=54ea2d86&lang=scss"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__